import { render } from "./SchoolServiceMonthlyContainer.vue?vue&type=template&id=4ec070ff&scoped=true&ts=true"
import script from "./SchoolServiceMonthlyContainer.vue?vue&type=script&lang=ts"
export * from "./SchoolServiceMonthlyContainer.vue?vue&type=script&lang=ts"

import "./SchoolServiceMonthlyContainer.vue?vue&type=style&index=0&id=4ec070ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec070ff"]])

export default __exports__